module.exports = __webpack_public_path__ + "img/prod-kxh.da3e498d.png";